import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[xmAriaDescBy]',
    standalone: false
})
export class XmAriaDescribedBy implements OnInit {
    @Input() public id: string = '';
    @Input() public additionalDescId: string = '';

    private element: HTMLElement;

    constructor(element: ElementRef) {
        Object.assign(this, { element: element.nativeElement });
    }

    public ngOnInit(): void {
        const value: string = this.additionalDescId ? `${this.additionalDescId}-aria-${this.id}` : `aria-${this.id}`;
        this.element.setAttribute('id', value);
        this.element.setAttribute('aria-describedby', value);
        this.element.setAttribute('aria-label', this.id);
    }
}
